<template>
	<td :colspan="headers.length" class="anim-fadein">
		<article class="TableDetail">
			<div class="TableDetail_head d-flex justify-end mb-3"></div>
			<div class="d-flex flex-wrap flex-md-nowrap gap-20">
				<div class="TableDetail_col">
					<div class="d-flex flex-wrap gap-10 mb-3">
						<v-card
							v-for="fieldKey in itemFields"
							:key="fieldKey"
							:class="[
								fieldKey.includes('message') ? 'long' : 'd-flex align-center',
								fieldKey.includes('mail') && 'copyable',
								(fieldKey === 'rooms_block' ||
									fieldKey === 'catering') &&
									'short',
							]"
							@click="
								fieldKey.includes('mail')
									? handleCopy(item[fieldKey])
									: null
							"
						>
							<span class="TableDetail_label primary--text mr-1 d-block">{{ formatLabel(fieldKey) }}:</span>
							<span
								v-if="!fieldKey.includes('_Url_')"
								class="flex-grow-1"
								:ref="
									fieldKey.includes('mail') ? 'clone' : null
								"
								@focus="
									fieldKey.includes('mail')
										? $event.target.select()
										: null
								"
								>{{
									formatValue(item[fieldKey], fieldKey)
								}}</span
							>
							<span
								class="flex-grow-1"
								v-if="fieldKey.includes('_Url_')"
								v-html="formatValue(item[fieldKey], fieldKey)"
							/>
							<v-tooltip
								v-if="fieldKey.includes('mail')"
								v-model="showCheck"
								color="success"
								bottom
							>
								<template v-slot:activator="{}">
									<span>
										<svg
											v-if="!showCheck"
											class="icon-copy d-block"
											xmlns="http://www.w3.org/2000/svg"
											width="18"
											height="18"
											viewBox="0 0 24 24"
										>
											<path
												fill="currentColor"
												d="M9.115 17q-.69 0-1.152-.462q-.463-.463-.463-1.153V4.615q0-.69.463-1.152Q8.425 3 9.115 3h7.77q.69 0 1.152.463q.463.462.463 1.152v10.77q0 .69-.462 1.153q-.463.462-1.153.462zm0-1h7.77q.23 0 .423-.192q.192-.193.192-.423V4.615q0-.23-.192-.423Q17.115 4 16.885 4h-7.77q-.23 0-.423.192q-.192.193-.192.423v10.77q0 .23.192.423q.193.192.423.192m-3 4q-.69 0-1.152-.462q-.463-.463-.463-1.153V6.615h1v11.77q0 .23.192.423q.193.192.423.192h8.77v1zM8.5 16V4z"
											/>
										</svg>
										<svg
											v-if="showCheck"
											class="icon-copied d-block"
											xmlns="http://www.w3.org/2000/svg"
											width="18"
											height="18"
											viewBox="0 0 24 24"
										>
											<path
												fill="currentColor"
												d="M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59z"
											/>
										</svg>
									</span>
								</template>
								<span>Copied</span>
							</v-tooltip>
						</v-card>

						<v-card class="long" v-if="item.comments">
							<span class="primary--text">Comments:</span>
							<br />
							<span>{{ item.comments }}</span>
						</v-card>

						<v-card class="long" v-if="showField(1)">
							<span class="primary--text">Turn Down Reason:</span>
							<br />
							<span>{{ getReason }}</span>
							<hr class="my-2" />
							<span class="primary--text">Turn Down Comment:</span>
							<br />
							<span>{{ item.turn_down_comment }}</span>
						</v-card>

                        <v-card class="long" v-if="showField(2)">
							<span class="primary--text">Lost Reason:</span>
							<br />
							<span>{{ getReason }}</span>
							<hr class="my-2" />
							<span class="primary--text">Lost Comment:</span>
							<br />
							<span>{{ item.lost_comment }}</span>
						</v-card>
					</div>
					<v-btn
						v-if="storeUser.isSuperUser"
						color="error"
						small
						@click="deleteLead"
						>Delete</v-btn
					>
				</div>
				<div class="TableDetail_col d-flex flex-column">
					<v-card>
						<div class="text-h6 primary--text">Internal Notes</div>
						<textarea
							v-model="item.internal_notes"
							:placeholder="
								!item.internal_notes && 'Add notes here...'
							"
						></textarea>
					</v-card>
					<div class="TableDetail_cta d-flex justify-end mt-3 gap-20">
						<v-btn
							color="primary"
							:disabled="saveNotesDisabled"
							small
							@click="updateInternalNote"
							>Save</v-btn
						>
						<download-csv
							class="Header_exportBtn v-btn v-size--small primary"
							:data="dataCSV"
							:name="fileName"
							:labels="fileHeaders"
							>Export Lead</download-csv
						>
					</div>
				</div>
			</div>
		</article>
	</td>
</template>

<script>
import * as dayjs from "dayjs";
import JsonCSV from "vue-json-csv";
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/utilities";
import { LEAD_STATUSES, BUS_EVENTS, REASONS_TYPE, REASON_TYPE_LOST } from "@/constants";

/**
 * COMMENTS EXCLUDED FROM LOOP TO HARDCODE IT AT THE END
 */
const excludedFields = [
	"first_name",
	"last_name",
	"site",
	"id",
	"sendto",
	"custom_view",
	"emailcc",
	"date",
	"comments",
	"i_agree",
	"subscribe",
	"status",
	"internal_notes",
	"lead_extra_id",
	"bcc",
	"mailchimp",
	"rooms_commission",
	"banquet_commission",
	"confirmation_id",
	"reference_id",
    "turn_down_comment",
    "turn_down_reason",
    "lost_reason",
    "lost_comment",
];

export default {
	name: "TableExpand",
	components: {
		"download-csv": JsonCSV,
	},
	props: {
		item: Object,
		headers: Array,
	},
	data() {
		return {
			saveNotesDisabled: true,
			showCheck: false,
			countFiles: 0,
			// fileHeaders: {
			// 	id: "Id",
			// 	date: "Date",
			// 	name: "Name",
			// 	email: "Email",
			// 	phone: "Phone",
			// 	event_date: "Event Date",
			// 	number_guests: "Number Of Attendees",
			// 	planner_type: "Planner Type",
			// 	budget_range: "Budget Range",
			// 	room_blocks: "Room Blocks",
			// 	catering: "Catering",
			// 	meeting_space: "Meeting Space",
			// 	comments: "Comments",
			// 	lead_extra_id: "Lead Extra Id",
			// 	status: "Status",
			// 	rooms: "Rooms",
			// 	banquet: "Banquet",
			// 	internal_notes: "Internal Notes",
			// },
		};
	},
	computed: {
		...mapGetters({ storeUser: "StateUser" }),
		fileHeaders() {
			const formattedEntries = Object.keys(this.item).map((key) => [
				key,
				key.replaceAll("_", " "),
			]);

			return Object.fromEntries(formattedEntries);
		},
		itemFields() {
			const extraExcluded = ["property", "city", "state", "hotel_class", "product_id", "rooms", "banquet", "type"];

			return Object.keys(this.item).filter(
				(field) =>
					!excludedFields.includes(field) &&
					!extraExcluded.includes(field) &&
					this.item[field] !== "" &&
					this.item[field] !== null
			);
		},
		fileName() {
			return `vlm_lead${
				this.item.id ? this.item.id : ""
			}-${dayjs().format("MMDDYYHHmmss")}.csv`;
		},
		itemDate() {
			return dayjs(this.item.event_date).format("MM/DD/YYYY");
		},
		itemDateEnd() {
			return dayjs(this.item.event_date_end).format("MM/DD/YYYY");
		},
		dataCSV() {
			const excludedKeys = ["site"];
			const filteredItem = Object.keys(this.item)
				.filter((key) => !excludedKeys.includes(key))
				.reduce((obj, key) => {
					obj[key] = this.item[key];
					return obj;
				}, {});

			return [filteredItem];
		},
		getReason() {
            if(this.item.status === LEAD_STATUSES.DOWN) {
                return REASONS_TYPE.find((reasonObj) => {
                    return reasonObj.key == this.item.turn_down_reason;
                }).value;
            }else {
                return REASON_TYPE_LOST.find((reasonObj) => {
                    return reasonObj.key == this.item.lost_reason;
                }).value;
            }
		},
	},
	watch: {
		"item.internal_notes"(oldVal, newVal) {
			if (
				newVal.trim() != "" &&
				this.item.status !== LEAD_STATUSES.DOWN
			) {
				this.saveNotesDisabled = false;
			} else if (
				newVal.trim() == "" ||
				this.item.status === LEAD_STATUSES.DOWN
			) {
				this.saveNotesDisabled = true;
			}
		},
	},
	methods: {
		...mapActions(["saveExtraLeads"]),
		formatValue(val, key) {
			const keyBelongsToDate = ["date", "arriv", "depart"].some((word) =>
				String(key).includes(word)
			);

			// DATE
			if (dayjs(val).isValid() && keyBelongsToDate) {
				return dayjs(val).format("MM/DD/YYYY");
			}

			// FILE URL
			if (String(key).includes("_Url_")) {
				let contLocal = this.countFiles;
				contLocal++;
				return `<a href="${val}" target="_blank">Attachment ${contLocal}</a>`;
			}

			// TO STRING IN CASE OF ARRAY|NUMBER
			return String(val).toString();
		},
		formatLabel(keyName) {
			if (
				keyName === "event_date" &&
				Object.keys(this.item).includes("event_date_end")
			) {
				return "Event Date Start";
			} else if (keyName.indexOf("_Url_") > -1) {
				return `Attached File${this.countFiles > 0 ? `s` : ``}`;
			}

			return keyName.replaceAll("_", " ");
		},
		deleteLead() {
			EventBus.$emit(BUS_EVENTS.LEAD_DELETE, this.item);
		},
		disableNotes() {
			this.saveNotesDisabled = true;
		},
		async updateInternalNote() {
			if (this.item.internal_notes.trim().length > 0) {
				const extrafields = new FormData();
				extrafields.append("lead_id", this.item.id);
				extrafields.append("internal_notes", this.item.internal_notes);

				try {
					const lead_extra_id = await this.saveExtraLeads(
						extrafields
					);
					this.item.lead_extra_id = lead_extra_id;
					this.saveNotesDisabled = true;

					EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED, {
						type: "success",
						message: "Lead Notes Saved Successfully",
						duration: 2e3,
					});
				} catch (error) {
					EventBus.$emit(BUS_EVENTS.ALERT_TRIGGERED, {
						type: "error",
						message:
							"Lead Notes cannot be saved. Please try again later.",
						duration: 2e3,
					});
					console.error(err.response.status);
				}
			} else {
				console.log("Internal Note is empty");
			}
		},
		handleCopy(email) {
			this.showCheck = !this.showCheck;
			if (navigator.clipboard) {
				navigator.clipboard.writeText(email);
			} else {
				this.$refs.clone.focus();
				document.execCommand("copy");
			}
			setTimeout(() => {
				this.showCheck = !this.showCheck;
			}, 2e3);
		},
		showField(status) {
			return this.item.status === ( status ==1 ? LEAD_STATUSES.DOWN : LEAD_STATUSES.LOST);
		}
	},
	beforeMount() {
		EventBus.$on(BUS_EVENTS.LEAD_UNEXPANDED, this.disableNotes);
	},
};
</script>

<style lang="scss" scoped>
@import "~@/scss/colors.scss";
.TableDetail {
	font-size: 13px;
	background: #efefef;
	padding: 20px 40px;
	padding-top: 0;
	border-radius: 0 0 6px 6px;
	position: relative;
	&_label {
		text-transform: capitalize;
	}
	&_close {
		font-size: 12px;
		color: #b3b3b3;
		display: inline-block;
		margin: 0;
		padding: 0.2em 0.8em 0.1em;
		border: 1px solid #c3c3c3;
		border-bottom: 0;
		border-radius: 6px 6px 0 0;
		font-weight: 500;
		position: absolute;
		bottom: 0;
		left: 50%;
		z-index: 1;
		transform: translateX(-50%);
	}
	&_col,
	.v-card {
		flex-basis: 45%;
		flex-grow: 1;
		flex-shrink: 0;
		&.short {
			flex-basis: 20%;
		}
		&.long {
			flex-basis: 100%;
		}
	}
	/deep/ .v-card {
		color: #121212;
		padding: 8px 16px;
		.text-h6 {
			font-size: 14px !important;
		}
		textarea {
			color: inherit;
			display: block;
			width: 100%;
			height: calc(100% - 40px);
			min-height: 150px;
			resize: none;
		}
	}

	/deep/ .v-card--link {
		cursor: default;
		&.copyable {
			cursor: pointer;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/TableSocial/TableExpand.vue